// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { seekerPreferences as fetch } from 'app/redux/modules/seekers';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';
import Loading from 'app/common/Loading';

import { Grid, Cell } from 'react-flexr';

import Input from 'app/common/form/input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LocationOn from '@mui/icons-material/LocationOn';

@connect(() => ({}), { fetch })
@i18n
class RentalPreferenceDialog extends Component {
  i18n;

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      data: null,
      reason: ''
    };
  }

  componentDidMount() {
    if (this.props.open === true && !this.state.open) {
      this.handleOpen();
    }
  }

  handleOpen = () => {
    this.setState({ open: true, loading: true });
    this.props
      .fetch(this.props.id)
      .then((result) => {
        this.setState({ loading: false, data: result.payload.result });
      })
      .catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
        this.setState({ loading: false, data: null });
      });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      this.setState({ open: false, loading: false, data: null });
    }
  };

  renderDialog() {
    const { fullScreen } = this.props;
    const { data, loading, open } = this.state;

    return (
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        open={open}
        onClose={this.handleClose}
      >
        <DialogTitle>{this.props.i18n('Rental preferences')}</DialogTitle>
        <DialogContent>
          {data ? (
            <Grid>
              <Cell size="1/2" palm="1/1">
                <Input
                  fullWidth
                  name="rent"
                  value={data.rent || this.props.i18n('Not specified')}
                  type="text"
                  label={this.props.i18n('Maximum rent')}
                />
              </Cell>
              <Cell size="1/2" palm="1/1">
                <Input
                  fullWidth
                  name="rooms"
                  value={data.rooms || this.props.i18n('Not specified')}
                  type="text"
                  label={this.props.i18n('Minimum rooms')}
                />
              </Cell>
              <Cell size="1/2" palm="1/1">
                <Input
                  fullWidth
                  name="size"
                  value={data.size || this.props.i18n('Not specified')}
                  type="text"
                  label={this.props.i18n('Minimum size')}
                />
              </Cell>
              <Cell size="1/2" palm="1/1">
                <Input
                  fullWidth
                  name="rentalPeriod"
                  value={data.rentalPeriod || this.props.i18n('Not specified')}
                  type="text"
                  label={this.props.i18n('Rental period')}
                />
              </Cell>
              <Cell size="2/2" palm="1/1">
                <Input
                  fullWidth
                  name="available"
                  value={data.available || this.props.i18n('Not specified')}
                  type="text"
                  label={this.props.i18n('Available')}
                />
              </Cell>
              <Cell size="1/2" palm="1/1">
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {this.props.i18n('Other requirements')}
                  {data.requirements.length ? (
                    data.requirements.map((name) => (
                      <div
                        key={name}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap'
                        }}
                      >
                        <CheckCircleOutlineIcon />
                        &nbsp;
                        <span>{this.props.i18n(name)}</span>
                      </div>
                    ))
                  ) : (
                    <span>{this.props.i18n('Not specified')}</span>
                  )}
                </div>
                <br />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {this.props.i18n('Dwelling types')}
                  {data.dwellingTypes.length ? (
                    data.dwellingTypes.map((name) => (
                      <div
                        key={name}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap'
                        }}
                      >
                        <CheckCircleOutlineIcon />
                        &nbsp;
                        <span>{this.props.i18n(name)}</span>
                      </div>
                    ))
                  ) : (
                    <span>{this.props.i18n('Not specified')}</span>
                  )}
                </div>
              </Cell>
              <Cell size="1/2" palm="1/1">
                {this.props.i18n('Locations')}
                {data.locations.length ? (
                  data.locations.map((name) => (
                    <div
                      key={name}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                      }}
                    >
                      <LocationOn />
                      <span>
                        &nbsp;
                        {this.props.i18n(name)}
                      </span>
                    </div>
                  ))
                ) : (
                  <span>{this.props.i18n('Not specified')}</span>
                )}
              </Cell>
            </Grid>
          ) : null}
          <div style={{ clear: 'both', height: '1em', display: 'block' }} />
          {loading ? <Loading /> : !data ? 'Something went wrong...' : null}
        </DialogContent>
        <DialogActions>
          <Button
            flat
            label={this.props.i18n('Close')}
            onClick={this.handleClose}
          />
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { label, icon } = this.props;
    return this.props.open === true ? (
      this.renderDialog()
    ) : (
      <div style={{ display: 'inline-block' }}>
        <Button flat label={label} icon={icon} onClick={this.handleOpen} />
        {this.renderDialog()}
      </div>
    );
  }
}

function RentalPreferenceDialogWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <RentalPreferenceDialog {...props} fullScreen={fullScreen} />;
}

export default RentalPreferenceDialogWithMobileDialog;